"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _NavBar = require("../NavBar/NavBar");
var _waffle = _interopRequireDefault(require("../../images/waffle.svg"));
require("./WaffleMenu.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const WaffleMenu = _ref => {
  let {
    links,
    cta,
    Link
  } = _ref;
  const {
    closeAllDropDowns,
    currentOpenMenu,
    sectorFlyoutDeployed,
    handleSectorFlyoutDeployed,
    languageSelectorDeployed,
    handleLanguageSelectorDeployed,
    desktopSearchDeployed,
    setDesktopSearchDeployed,
    isWaffleMenuDeployed,
    setWaffleMenuDeployed
  } = (0, _react.useContext)(_NavBar.NavBarContext);
  (0, _react.useEffect)(() => {
    if (currentOpenMenu) {
      setWaffleMenuDeployed(false);
    }
  }, [currentOpenMenu]);
  (0, _react.useEffect)(() => {
    if (sectorFlyoutDeployed) {
      setWaffleMenuDeployed(false);
    }
  }, [sectorFlyoutDeployed]);
  (0, _react.useEffect)(() => {
    if (languageSelectorDeployed) {
      setWaffleMenuDeployed(false);
    }
  }, [languageSelectorDeployed]);
  (0, _react.useEffect)(() => {
    if (desktopSearchDeployed) {
      setWaffleMenuDeployed(false);
    }
  }, [desktopSearchDeployed]);
  const handleClick = () => {
    closeAllDropDowns();
    handleSectorFlyoutDeployed(false);
    handleLanguageSelectorDeployed(false);
    setDesktopSearchDeployed(false);
    setWaffleMenuDeployed(!isWaffleMenuDeployed);
  };
  if (Array.isArray(links) && links.length > 0) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "luna-waffle-menu"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "luna-waffle-menu__selector"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: `luna-waffle-menu__selector__button ${isWaffleMenuDeployed ? "luna-waffle-menu__selector__button--active" : ""}`,
      onClick: handleClick
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _waffle.default,
      width: "20",
      height: "20",
      alt: ""
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: `luna-waffle-menu__drop-down ${isWaffleMenuDeployed ? "luna-waffle-menu__drop-down--active" : ""}`
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "luna-waffle-menu__drop-down__options"
    }, links.map((_ref2, i) => {
      let {
        title,
        description,
        linkText,
        externalUrl
      } = _ref2;
      return /*#__PURE__*/_react.default.createElement("li", {
        key: i,
        className: "luna-waffle-menu__drop-down__menu-item"
      }, /*#__PURE__*/_react.default.createElement("h4", {
        className: "luna-waffle-menu__drop-down__menu-item__product-name"
      }, title), /*#__PURE__*/_react.default.createElement("div", {
        className: "luna-waffle-menu__drop-down__menu-item__description"
      }, description), /*#__PURE__*/_react.default.createElement("div", {
        className: "luna-waffle-menu__drop-down__menu-item__cta"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: externalUrl,
        className: "luna-waffle-menu__drop-down__menu-item__cta__link",
        target: "_blank"
      }, linkText)));
    })), cta?.url && /*#__PURE__*/_react.default.createElement("footer", {
      className: "luna-waffle-menu__drop-down__footer"
    }, /*#__PURE__*/_react.default.createElement(Link, {
      to: cta?.url,
      className: "luna-waffle-menu__drop-down__footer__link"
    }, cta?.title))));
  } else {
    return /*#__PURE__*/_react.default.createElement("div", null);
  }
};
var _default = WaffleMenu;
exports.default = _default;
WaffleMenu.propTypes = {
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    description: _propTypes.default.string,
    linkText: _propTypes.default.string,
    externalUrl: _propTypes.default.string
  })),
  cta: _propTypes.default.shape({
    title: _propTypes.default.string,
    url: _propTypes.default.string
  })
};